import { createCsv } from '@fitogest/reactive-form-builder/csv';
import { FormType } from '@fitogest/reactive-form-builder/interfaces';
import {TareasApiService} from '../../../../service/api/tareas-api.service';
import { Component, AfterViewInit, OnInit } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Router} from '@angular/router';
import {DashboardService} from '../../../../service/events/dashboard.service';
import {RequestHandler} from '../../../../service/OffService/request-handler';
import {BaseView} from '../../../base-view';
import moment, { Moment } from 'moment';
import { environment } from 'src/environments/environment';
import { Filtering } from 'src/app/service/filtering/filtering';
import {StorageManager} from '../../../../common/storage-manager.class';

import { TareaAlquilerMaquinariaModel } from 'src/app/models/tareas/tarea-alquiler-maquinaria.model';
import { FincasModel } from 'src/app/models/form-common/fincas.module';
import { ColInterface } from 'src/app/common/components/common-list-table/col.interface';
import { ColStylesInterface } from 'src/app/common/components/common-list-table/col-styles.interface';
import { TreeNode } from 'primeng/api';
import { maquinaria, TareasAlquilerMaquinariaFormDefinition } from './tareas-alquiler-maquinaria-form/form-control/form-definition';

@Component({
    selector: 'app-tareas-alquiler-maquinaria-general',
    standalone: false,
    templateUrl: './tareas-alquiler-maquinaria.component.html',
    styleUrls: ['./tareas-alquiler-maquinaria.component.scss']
})
export class TareasAlquilerMaquinariaComponent extends BaseView<TareaAlquilerMaquinariaModel> implements OnInit, AfterViewInit {

    public rolUser = StorageManager.getUser().rol;
    public hiddenButtonDelete = false;

    public appName = environment.appName;
    public serverUrl = environment.serverUrl;
    public fincaName = environment.features.fincaName; 
    public hasClients = environment.features.hasClients;
    public userCanSeeClientes = this.hasClients &&
  (environment.features.userCanSeeClientes ? true : (StorageManager.getUser().rol === 'admin'));     

    public getRequest: RequestHandler<TareaAlquilerMaquinariaModel[]> = this.tareasApi.alquilerMaquinaria.GET;
    public deleteRequest: RequestHandler<TareaAlquilerMaquinariaModel> = this.tareasApi.alquilerMaquinaria.DELETE;
    public pathToForm = 'alquiler-maquinaria';  
    public menuItemId = 'alquiler-maquinaria';  

    public totalHoras: Moment | string = '00:00';
    
    public auxTotalHoras: Moment | string = '00:00';
    

    public override filtering: Filtering<TareaAlquilerMaquinariaModel> = new Filtering<TareaAlquilerMaquinariaModel>();
    public override canShow: Record<string, boolean> = {};
    public override model: TareaAlquilerMaquinariaModel = {};

    public form: TareasAlquilerMaquinariaFormDefinition | null = null;

    public optionsSelectButton = [
        { label: 'Todos', value: 0 },
        { label: 'Si', value: 1 },
        { label: 'No', value: 2 },
    ];

    public readonly realizadoControl = new FormControl<number>(0, { nonNullable: true });

    public selectedYears = 0;
    public currentYear = '';
    public currentUser = StorageManager.getUser();

    public fincas: FincasModel[] = [];

    public showReceta = false;
    public showRecetaGlobalGAP = environment.features.showRecetaGlobalGAP;
    public showUsuariosFirma = environment.features.showUsuariosFirma;
    public showClientesFirma = environment.features.showClientesFirma;
    public cols: ColInterface[] = [
        {field: 'cliente_nombre', header: 'Cliente', filter: ''},
        {field: 'trabajadores_nombres', header: 'Empleado', filter: ''},
        {field: 'finca', header: this.fincaName, filter: ''},
        {field: 'fecha', header: 'Fecha', filter: ''},
        {field: 'maquina', header: 'Maquina', filter: ''},
        {field: 'prioridad', header: 'Prioridad/Realizada', filter: ''},
        {field: 'horas_totales', header: 'Horas Totales', filter: ''},
        {field: 'observaciones', header: 'Observaciones', filter: ''},
    ];  

    public fecha: {inicio: string; fin: string} = {
        inicio: '',
        fin: '',
    };

    constructor(public tareasApi: TareasApiService,
        private dashboard: DashboardService,
        private router: Router) {
        super(dashboard, tareasApi.alquilerMaquinaria.GET, tareasApi.alquilerMaquinaria.DELETE);
  
  
    }

    ngOnInit() {
    
        if (environment.features.showTareasMto){
      
            if (this.rolUser !== 'admin'){
                this.hiddenButtonDelete = true;
            }
        }
    
        this.dashboard.setSubmenuItem('tareas', this.menuItemId);
        this.filtering.addFilter((copy: TreeNode<TareaAlquilerMaquinariaModel>[] | void) => 
            (copy as TreeNode<TareaAlquilerMaquinariaModel>[]).filter(row => {
                const tareaAlquiler = row as TareaAlquilerMaquinariaModel;

                switch (this.realizadoControl.value) {
                case 1:
                    return ['Realizada'].includes(tareaAlquiler.prioridad ?? '');
                case 2:
                    return !['Realizada'].includes(tareaAlquiler.prioridad ?? '');
                default:
                    return true;
                }
            }));

        /*** 
   *  En el caso de que el usuario no se admin,
   * filtrará por su id de usuario que coincide,
   *  con el id trabajador   
  */
        if ( StorageManager.getUser().rol !== 'admin' ){ 
            this.filtering.addFilter((copy: TreeNode<TareaAlquilerMaquinariaModel>[] | void) => 
                (copy as TreeNode<TareaAlquilerMaquinariaModel>[]).filter(row => {
                    const tareaAlquiler = row as TareaAlquilerMaquinariaModel;

                    if (tareaAlquiler.ids_trabajadores != null ) {
              
                        const idTrabajador = StorageManager.getUser().id;
                        const listaTrabajadores = (tareaAlquiler.ids_trabajadores as string).split(';');
                        if ( listaTrabajadores.find( id => id === idTrabajador?.toString() ) ) {
                            return true;
                        }
              
                    }
                    return false;
                }));
        }
    
        /*** 
       *  Fin de filtrar por id_usuario = trabajador,
       *   
      */
        this.filtering.addFilter((copy: TreeNode<TareaAlquilerMaquinariaModel>[] | void) => 
            (copy as TreeNode<TareaAlquilerMaquinariaModel>[]).filter(row => {
                const tareaAlquiler = row as TareaAlquilerMaquinariaModel;

                if (this.fecha.inicio && this.fecha.fin && tareaAlquiler.fecha) {
    
                    const arrayFecha = tareaAlquiler.fecha.toString().split('/');
                    const fechaAux = arrayFecha[2] + '-' + arrayFecha[1] + '-' + arrayFecha[0];
    
                    if (
                        (moment(moment(this.fecha.inicio).format('YYYY-MM-DD')).diff(fechaAux) <= 0) && 
                    (moment(moment(this.fecha.fin).format('YYYY-MM-DD')).diff(fechaAux) >= 0)
                    ) {
                        return true;
                    } else {
                        return false;
                    }
                } else {
                    return true;
                }
            }));
    }

    public add() {
        if (!StorageManager.getClient() && this.userCanSeeClientes) {
            this.dashboard.openClientDialog();
        } else {
            this.router.navigate(['dashboard', 'crear-' + this.pathToForm]);
        }
    }
  
    public edit(data: TareaAlquilerMaquinariaModel) {
        //console.log('data',data);
      
        this.router.navigate(['dashboard', 'editar-alquiler-maquinaria', data.id]);
    }
  
    public duplicate(data: TareaAlquilerMaquinariaModel) {
        this.router.navigate(['dashboard', 'duplicar-alquiler-maquinaria', data.id]);
    }  

    public override deleteRegister() {
        if (this.model.id) {
            this.deleteRequest.safePerform(this.model);
            this.deleteRequest.response(() => {
                if (!this.deleteRequest.hasError) {
                    this.getRequest.safePerform();
                }
            });
        } else {
            this.deleteRequest.hasError = true;
            throw new Error('Trying to DELETE a register without primary key');
        }
    }  
    public override show(modal: string, data: TareaAlquilerMaquinariaModel): void {
        const modalData = { ...data } as TareaAlquilerMaquinariaModel;
        this.coerceSwitchFields(modalData);
        super.show(modal, modalData);

        const formType = modal === 'delete' ? +FormType.DELETION : +FormType.INFORMATIVE;
        this.form = new TareasAlquilerMaquinariaFormDefinition(formType, modalData);
    }

    public override hide(modal: string) {
        this.model = {};
        this.form = null;
        this.canShow[modal] = false;
        this.deleteRequest.reset();
    }

    private coerceSwitchFields(_data: TareaAlquilerMaquinariaModel): void {
        // This module does not need list-only switch coercions.
    }

    public globalConditionalStyle(value: string, col: ColInterface): ColStylesInterface {
        if (col.field === 'prioridad') {
            if (value === 'Alta') {
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#f44242'
                    },  
                };
            }
            else if (value === 'Realizada'){
                return {
                    textAlign: 'center',
                    rowStyle: {
                        backgroundColor: '#00ff00'
                    },  
                };
            }
        }

        if (col.field === 'trabajadores_nombres') {
            return {
                textAlign: 'center',
                style: {
                    'max-width': '50px',
                }
            };
        }
        if (col.field === 'observaciones') {
            return {
                textAlign: 'center',
                style: {
                    'max-width': '50px',
                }
            };
        }
        return {textAlign: 'center'};
    }
  
    public globalVisualTransform(value: string, col: ColInterface): string {  
        if (col.field === 'maquina'){
            return maquinaria.filtered.find(it => it.value === value) ? 
                maquinaria.filtered.find(it => it.value === value)?.label ?? '' : 
                '';
        }
        return value;
    }
  
    public formatDate(date: string) {
        moment.locale('es');
        return moment(date, 'DD/MM/YYYY').format('LL');
    }  
  
    filtrar(): void {
        this.filtering.filter();
        this.updateFooter();
    }

    public override updateFooter() {
        this.sum();
    }
      
    public override sum() {
        this.totalHoras = moment(new Date('October 1, 2014 00:00:00'));
        this.auxTotalHoras = moment(new Date('October 1, 2014 00:00:00'));
        let contador = 0;
    
        (this.filtering.value || []).forEach((tareas, index ) => {
                const horasTotales = (tareas as TareaAlquilerMaquinariaModel).horas_totales;
    
                if (horasTotales != null ) {
         
                    if (horasTotales.length > 0) {
                        contador++;
                        const horaMinuto = horasTotales.split(':');
                        
                        this.totalHoras = moment(this.totalHoras).add(horaMinuto[0], 'hours').add(horaMinuto[1], 'minutes');
                    }
                }
      
                if ( index + 1 >= (this.filtering.value as TareaAlquilerMaquinariaModel[]).length ){
        
                    let minutos = moment(this.totalHoras).format('mm');
            
            
                    let differencia = moment(this.totalHoras).diff(this.auxTotalHoras);
            
                    if ( minutos.toString().length === 0) {
                        minutos = '00';
                    }
      
                    if ( minutos.toString().length === 1) {
                        minutos = '0' + minutos.toString();
                    }
                    differencia = differencia / (1000 * 60 * 60);
                    differencia = Math.abs(Math.floor(differencia));
                    this.totalHoras = differencia + ':' + minutos;
            
                    if ( contador === 0){
                        this.totalHoras = '00:00';
                    }
      
                }
        
          
            });
      
            if ( contador === 0){
                this.totalHoras = '00:00';
            }
            this.filtering.filter();
    }
    public downloadCsv(): void {
        this.form = new TareasAlquilerMaquinariaFormDefinition(+FormType.EXPORT, {});

        const csvData = ((this.filtering.value ?? []) as TareaAlquilerMaquinariaModel[]).map((item) => {
            const machineValue = String(item.maquina ?? '');
            const machineLabel = maquinaria.filtered.find((option) => String(option.value) === machineValue)?.label ?? '';

            return {
                ...item,
                maquina: machineLabel,
            };
        });

        const csvContent = createCsv(this.form.fieldNames, this.form.fieldLabels, csvData);
        const csvLink = document.getElementById('csvLink') as HTMLAnchorElement | null;

        if (csvLink) {
            csvLink.download = 'Alquiler maquinaria.csv';
            csvLink.href = encodeURI(csvContent);
            csvLink.click();
        }
    }

    getFechaInicio(event: string | Date) {
        this.fecha.inicio = this.getFilterDate(event);
        this.filtering.filter();
  
    }
    getFechaFin(event: string | Date) {
        this.fecha.fin = this.getFilterDate(event);
        this.filtering.filter();
    }

    private getFilterDate(event: string | Date): string {
        const date = event instanceof Date ? moment(event) : moment(event, ['DD/MM/YYYY', 'YYYY-MM-DD'], true);

        return date.isValid() ? date.format('YYYY-MM-DD') : '';
    }

    ngAfterViewInit() {
        this.tareasApi.alquilerMaquinaria.GET.response(() => {
            this.updateFooter();
            this.sum();
        });
    }
}